import React from "react";
import { Pencil, Replace } from "lucide-react";
import { SmartLink } from "@/services/bedrock/dtos";
import { SmartLinkCard } from "@/containers";

interface SmartLinkDecisionViewProps {
  smartLink: SmartLink;
  onEditGlobally: () => void;
  onChooseDifferent: () => void;
}

export const SmartLinkDecisionView: React.FC<SmartLinkDecisionViewProps> = ({
  smartLink,
  onEditGlobally,
  onChooseDifferent,
}) => {
  return (
    <div className="flex flex-col gap-3 py-2">
      <SmartLinkCard smartLink={smartLink} />

      <button
        type="button"
        onClick={onEditGlobally}
        className="flex items-start gap-4 p-4 text-left border rounded-xl hover:border-primary hover:bg-slate-50 transition-all group"
      >
        <div className="bg-slate-100 p-2.5 rounded-lg group-hover:bg-primary/10 group-hover:text-primary transition-colors">
          <Pencil className="size-5" />
        </div>
        <div className="flex flex-col gap-1">
          <span className="font-semibold text-foreground">Edit Globally</span>
          <p className="text-sm text-muted-foreground font-sans">
            Update name or URL for this link. This will update <strong>all published posts</strong> currently using this
            link to point to the new destination.
          </p>
        </div>
      </button>

      <button
        type="button"
        onClick={onChooseDifferent}
        className="flex items-start gap-4 p-4 text-left border rounded-xl hover:border-primary hover:bg-slate-50 transition-all group"
      >
        <div className="bg-slate-100 p-2.5 rounded-lg group-hover:bg-primary/10 group-hover:text-primary transition-colors">
          <Replace className="size-5" />
        </div>
        <div className="flex flex-col gap-1">
          <span className="font-semibold text-foreground">Select or Create a New Smart Link</span>
          <p className="text-sm text-muted-foreground font-sans">
            Choose a different link from your library or create a brand new one. This will only affect this post and
            future posts.
          </p>
        </div>
      </button>
    </div>
  );
};
